import { Box, Button, Flex, Text, Tooltip } from '@chakra-ui/react';
import { textStyle } from 'theme/names';
import { GenerateButtonProps, TagsSelectorProps } from 'types/tagsSelecter';
const buttonSelectedColor = '#263754';

const generateButton = ({
  formatTag,
  isActive,
  onClick,
  buttonStyle,
}: GenerateButtonProps) => {
  return (
    <Tooltip label={formatTag?.hoverText || ''} key={formatTag.value}>
      <Button
        onClick={() => onClick(formatTag.value)}
        isActive={isActive(formatTag.value)}
        _hover={{ bg: buttonSelectedColor, color: 'white' }}
        _active={{ bg: buttonSelectedColor, color: 'white' }}
        variant='outline'
        color={buttonSelectedColor}
        fontWeight='600'
        borderRadius='20px'
        style={buttonStyle}
      >
        {formatTag.label}
      </Button>
    </Tooltip>
  );
};

const TagsSelector = ({
  title,
  titleInfo,
  tags,
  selectedTag,
  setSelectedTag,
  containerStyle = {},
  titleStyle = {},
  tagContainerStyle = {},
  buttonStyle = {},
}: TagsSelectorProps) => {
  return (
    <Box pt='8' style={{ ...containerStyle }}>
      <Text
        pl='10'
        fontSize={['md', 'lg']}
        fontWeight='bold'
        textStyle={textStyle['body.medium.primary']}
        style={{ ...titleStyle }}
      >
        {title}{' '}
        {titleInfo && (
          <Text fontSize='md' fontWeight='normal' as='i'>
            {titleInfo}
          </Text>
        )}
      </Text>

      <Flex flexWrap='wrap' gap='3' pt='5' style={{ ...tagContainerStyle }}>
        {tags.map((tag, i) =>
          generateButton({
            formatTag: tag,
            isActive: selectedTag,
            onClick: setSelectedTag,
            buttonStyle,
          })
        )}
      </Flex>
    </Box>
  );
};

export default TagsSelector;
